import FetchStatusRepository   from "../../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyMessage           from "../../../../domain/fundamentals/message/notify/NotifyMessage";
import NotifyRepository        from "../../../../domain/fundamentals/message/notify/NotifyRepository";
import NotifyType              from "../../../../domain/fundamentals/message/notify/NotifyType";
import MailSend                from "../../../../domain/mail/send/MailSend";
import MailSendRepository      from "../../../../domain/mail/send/MailSendRepository";
import FetchStatusDataSource   from "../../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import MailSendDataSource      from "../../../../infrastructure/datasource/mail/send/MailSendDataSource";
import NotifyDataSource        from "../../../../infrastructure/datasource/notify/NotifyDataSource";
import SetValidateErrorMessage from "../../error/SetValidateErrorMessage";

class SendMail {
  private readonly mailSendRepository: MailSendRepository = new MailSendDataSource(this.dispatch);
  private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(this.dispatch);
  private readonly notifyRepository: NotifyRepository = new NotifyDataSource(this.dispatch);
  private readonly setValidateErrorMessage: SetValidateErrorMessage = new SetValidateErrorMessage(this.dispatch);

  constructor(private readonly dispatch) {
  }

  public async execute(mailSend: MailSend) {
    this.fetchStatusRepository.start();
    try {
      const response = await this.mailSendRepository.send(mailSend);
      if (response.data.errors.length > 0) {
        // APIの処理は正常だがその先でエラー/当月の送信件数が超過
        response.data.errors.forEach(error => this.notifyRepository.optionalMessage(NotifyType.OPTIONAL_FAILURE, new NotifyMessage(error)));
      } else {
        this.notifyRepository.mailSendSuccess();
      }
    } catch (e) {
      this.setValidateErrorMessage.execute(e);
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default SendMail;
